/* tslint:disable */
import { Injectable } from '@angular/core';
import { Email } from '../../models/Email';
import { Payee } from '../../models/Payee';
import { PayeeAccountDetail } from '../../models/PayeeAccountDetail';
import { PayeeDetail } from '../../models/PayeeDetail';
import { PayeeShareholder } from '../../models/PayeeShareholder';
import { Storage } from '../../models/Storage';
import { BusinessType } from '../../models/BusinessType';
import { PayeeAttachment } from '../../models/PayeeAttachment';
import { PayeeWebChecklist } from '../../models/PayeeWebChecklist';
import { PayeePaymentProcessing } from '../../models/PayeePaymentProcessing';
import { PayeeBusinessSales } from '../../models/PayeeBusinessSales';
import { PayeeEStatementAdmin } from '../../models/PayeeEStatementAdmin';
import { PayeeECommerceAdmin } from '../../models/PayeeECommerceAdmin';
import { PayeeReportingPdp } from '../../models/PayeeReportingPdp';
import { PayeeSalesHistory } from '../../models/PayeeSalesHistory';
import { PayeeService } from '../../models/PayeeService';
import { PayeeServiceDPE } from '../../models/PayeeServiceDPE';
import { PayeeServiceM2Ubiller } from '../../models/PayeeServiceM2Ubiller';
import { PayeeSubmission } from '../../models/PayeeSubmission';
import { Service } from '../../models/Service';
import { SubmissionTag } from '../../models/SubmissionTag';
import { SubmissionSubtagMapping } from '../../models/SubmissionSubtagMapping';
import { Tag } from '../../models/Tag';
import { SubTag } from '../../models/SubTag';
import { Group } from '../../models/Group';
import { PayeeAttachmentDetail } from '../../models/PayeeAttachmentDetail';
import { PayeeServiceMID } from '../../models/PayeeServiceMID';
import { PayeeCardsEcommerce } from '../../models/PayeeCardsEcommerce';
import { PayeePosOutlet } from '../../models/PayeePosOutlet';
import { PayeePos } from '../../models/PayeePos';
import { PayeeFraudChecklist } from '../../models/PayeeFraudChecklist';
import { PayeePCIDSS } from '../../models/PayeePCIDSS';
import { RequestAssistance } from '../../models/RequestAssistance';
import { PayeePosPaymentProcessing } from '../../models/PayeePosPaymentProcessing';
import { PayeePosEstatementAdmin } from '../../models/PayeePosEstatementAdmin';

export interface Models { [name: string]: any }

@Injectable()
export class SDKModels {

  private models: Models = {
    Email: Email,
    Payee: Payee,
    PayeeAccountDetail: PayeeAccountDetail,
    PayeeDetail: PayeeDetail,
    PayeeShareholder: PayeeShareholder,
    Storage: Storage,
    BusinessType: BusinessType,
    PayeeAttachment: PayeeAttachment,
    PayeeWebChecklist: PayeeWebChecklist,
    PayeePaymentProcessing: PayeePaymentProcessing,
    PayeeBusinessSales: PayeeBusinessSales,
    PayeeEStatementAdmin: PayeeEStatementAdmin,
    PayeeECommerceAdmin: PayeeECommerceAdmin,
    PayeeReportingPdp: PayeeReportingPdp,
    PayeeSalesHistory: PayeeSalesHistory,
    PayeeService: PayeeService,
    PayeeServiceDPE: PayeeServiceDPE,
    PayeeServiceM2Ubiller: PayeeServiceM2Ubiller,
    PayeeSubmission: PayeeSubmission,
    Service: Service,
    SubmissionTag: SubmissionTag,
    SubmissionSubtagMapping: SubmissionSubtagMapping,
    Tag: Tag,
    SubTag: SubTag,
    Group: Group,
    PayeeAttachmentDetail: PayeeAttachmentDetail,
    PayeeServiceMID: PayeeServiceMID,
    PayeeCardsEcommerce: PayeeCardsEcommerce,
    PayeePosOutlet: PayeePosOutlet,
    PayeePos: PayeePos,
    PayeeFraudChecklist: PayeeFraudChecklist,
    PayeePCIDSS: PayeePCIDSS,
    RequestAssistance: RequestAssistance,
    PayeePosPaymentProcessing: PayeePosPaymentProcessing,
    PayeePosEstatementAdmin: PayeePosEstatementAdmin,
    
  };

  public get(modelName: string): any {
    return this.models[modelName];
  }

  public getAll(): Models {
    return this.models;
  }

  public getModelNames(): string[] {
    return Object.keys(this.models);
  }
}
